import React from "react";

/**
 * BETA MODE — closed beta (6-12 months).
 *
 * Trial countdown is intentionally disabled during the beta because every
 * authenticated user receives full Premium access for free. The component
 * is kept as an inert export so existing imports (e.g. TopBar) continue
 * to compile without changes; we'll restore the original behaviour when
 * the public/paid launch happens.
 */
const DAY_MS = 86_400_000;

export const trialDaysLeft = (expiresAt) => {
  if (!expiresAt) return 0;
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return 0;
  return Math.ceil(ms / DAY_MS);
};

const TrialCountdownChip = () => null;

export default TrialCountdownChip;
